// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ZhihuSquareFilledSvg from "@ant-design/icons-svg/es/asn/ZhihuSquareFilled";
import AntdIcon from '../components/AntdIcon';

var ZhihuSquareFilled = function ZhihuSquareFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ZhihuSquareFilledSvg
  }));
};

ZhihuSquareFilled.displayName = 'ZhihuSquareFilled';
export default React.forwardRef(ZhihuSquareFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/ZhihuSquareFilled.js
// module id = 2091
// module chunks = 0